import React, { useMemo } from "react";

const CSVTable = ({value}) => {
  const removeQuotes = (str) =>
    str
      ?.match(/^['"]?(.*?)['"]?$/)
      ?.slice(1, 2)
      ?.pop();
  const renderRows = () => {
    return value
      .split(/\r?\n|\r/)
      .filter((el) => !el.match(/^\s*$/))
      .map((row) => row.split(","))
      .map((row) => row.map(removeQuotes))
      .map((row, rin) => (
        <tr key={rin}>
          {row.map((cell, cin) => (
            <td key={cin}>{cell}</td>
          ))}
        </tr>
      ));
  };

  const renderHead = () =>
    value
      .match(/(.*?)\r?\n|\r/)
      ?.slice(0, 1)
      ?.pop()
      ?.split(",")
      ?.map(removeQuotes)
      ?.map((cell, i) => <th key={i}>{cell}</th>);

  const rows = useMemo(renderRows, [value]);
  const head = useMemo(renderHead, [value]);

  return (
    <table className="table">
      <thead>
        <tr>{head}</tr>
      </thead>
      <tbody>{rows}</tbody>
    </table>
  );
};

export default CSVTable;
